export default "__VITE_ASSET__b4e54f1a__"